import {
    SET_SELECTED_ITEM,
    PRODUCT_DETAILS_OPENED,
    OPEN_PAYMENT_OAUTH_WINDOW,
    GUEST_SIGNUP,
    DETAILS_FORM_SUBMITTED,
    EXPRESS_CHECKOUT_AVAILABLE,
    EXPRESS_CHECKOUT_CLICKED,
    PRODUCT_SHIPPING_OPENED,
    SHIPPING_DETAILS_SUBMITTED,
    SET_FORM_FIELD_INVALID,
    CLOSE_PAYMENTS_MODAL_BUTTON_CLICKED,
    GOTO_SHIPPING_ADDRESS_PAGE,
    GOTO_PAYMENT_METHOD_PAGE,
    GOTO_CHECKOUT_PAGE,
    GOTO_ORDER_COMPLETE_PAGE,
    GOTO_ITEM_DETAILS_PAGE,
    PAYMENT_METHOD_OPENED,
    PAYMENT_METHOD_SUBMITTED,
    ORDER_DETAILS_OPENED,
    ORDER_DETAILS_SUBMITTED,
    ORDER_PAYMENT_SUCCESS,
    ORDER_CONFIRMATION_OPENED,
    ORDER_CONFIRMATION_CLOSED,
    PAYMENT_MOUSE_ENTERED,
} from '../paymentActions'
import { TourActions } from 'aria-viewer/tour'
import { PaymentConstants } from '../paymentConstants'
import { mainMediaHasPaymentHotspots } from 'aria-viewer/utils/functions'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants/desktopAnalytics'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'
import { getPaymentProperties, getPaymentPropertiesWithShippingAddress } from './analyticUtils'

const paymentDesktopAnalytics = {
    [SET_SELECTED_ITEM]: (getState, action) => {
        const { inst_name, owner_id, loc_name, loc_id, stoptitle, stopid } = getTourData()(getState)
        const { itemId, item } = action

        return trackEvent(EVENTS.EXP_SCENEPAY_BUTTON_CLICKED, {
            Institution: inst_name,
            Inst_ID: owner_id,
            Location: loc_name,
            Loc_ID: loc_id,
            Stop: stoptitle,
            Stop_ID: stopid,
            Item: item,
            Item_ID: itemId,
        })
    },

    [PRODUCT_DETAILS_OPENED]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_ITEMDET_POPUP_VIEWED, paymentProperties)
    },

    [OPEN_PAYMENT_OAUTH_WINDOW]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)
        const {
            oauthState: { authType },
        } = action

        let event

        switch (authType) {
            case PaymentConstants.userAuthTypes.FACEBOOK:
                event = EVENTS.EXP_ITEMDET_FACEBOOK_CLICKED
                break
            case PaymentConstants.userAuthTypes.GOOGLE:
                event = EVENTS.EXP_ITEMDET_GOOGLE_CLICKED
                break
            default:
                return
        }

        return trackEvent(event, paymentProperties)
    },

    [GUEST_SIGNUP]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_ITEMDET_GUEST_CLICKED, paymentProperties)
    },

    [DETAILS_FORM_SUBMITTED]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_ITEMDET_BUY_CLICKED, paymentProperties)
    },

    [EXPRESS_CHECKOUT_AVAILABLE]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_ITEMDET_EXPRESSCHECKOUT_VIEWED, paymentProperties)
    },

    [EXPRESS_CHECKOUT_CLICKED]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_ITEMDET_EXPRESSCHECKOUT_CLICKED, paymentProperties)
    },

    [PRODUCT_SHIPPING_OPENED]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_SHIPDETS_VIEWED, paymentProperties)
    },

    [SHIPPING_DETAILS_SUBMITTED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_SHIPDETS_SUBMIT, paymentProperties)
    },

    [SET_FORM_FIELD_INVALID]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)
        const { formName } = action

        let event

        switch (formName) {
            case PaymentConstants.formNames.SHIPPING_ADDRESS:
                event = EVENTS.EXP_SHIPDETS_SUBMIT_ERROR
                break
            case PaymentConstants.formNames.STRIPE_PAYMENT_METHOD:
                event = EVENTS.EXP_PAYMETH_SUBMIT_ERROR
                break
            case PaymentConstants.formNames.CHECKOUT:
                event = EVENTS.EXP_ORDDETS_PLACEORDER_ERROR
                break
            default:
                return
        }

        return trackEvent(event, paymentProperties)
    },

    [CLOSE_PAYMENTS_MODAL_BUTTON_CLICKED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)
        const { paymentPageName } = getTourData()(getState)

        let event

        switch (paymentPageName) {
            case GOTO_ITEM_DETAILS_PAGE:
                event = EVENTS.EXP_ITEMDET_POPUP_CLOSED
                break
            case GOTO_SHIPPING_ADDRESS_PAGE:
                event = EVENTS.EXP_SHIPDETS_CLOSED
                break
            case GOTO_PAYMENT_METHOD_PAGE:
                event = EVENTS.EXP_PAYMETH_CLOSED
                break
            case GOTO_CHECKOUT_PAGE:
                event = EVENTS.EXP_ORDDETS_CLOSED
                break
            case GOTO_ORDER_COMPLETE_PAGE:
                event = EVENTS.EXP_ITEMPURCHASED_CLOSED
                break
            default:
                return {}
        }

        return trackEvent(event, paymentProperties)
    },

    [PAYMENT_METHOD_OPENED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_PAYMETH_VIEWED, paymentProperties)
    },

    [PAYMENT_METHOD_SUBMITTED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_PAYMETH_SUBMIT, paymentProperties)
    },

    [ORDER_DETAILS_OPENED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_ORDDETS_VIEWED, paymentProperties)
    },

    [ORDER_DETAILS_SUBMITTED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_ORDDETS_PLACEORDER_CLICKED, paymentProperties)
    },

    [ORDER_PAYMENT_SUCCESS]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_ORDDETS_PLACEORDER_SUCCESS, paymentProperties)
    },

    [ORDER_CONFIRMATION_OPENED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_ITEMPURCHASED_VIEWED, paymentProperties)
    },

    [ORDER_CONFIRMATION_CLOSED]: (getState, action) => {
        const paymentProperties = getPaymentPropertiesWithShippingAddress()(getState)

        return trackEvent(EVENTS.EXP_ITEMPURCHASED_CONTINUE, paymentProperties)
    },

    [PAYMENT_MOUSE_ENTERED]: (getState, action) => {
        const paymentProperties = getPaymentProperties()(getState)

        return trackEvent(EVENTS.EXP_SCENEPAY_HOVER_VIEWED, paymentProperties)
    },

    [TourActions.MAIN_MEDIA_LOADING_STATUS]: (getState, action) => {
        const { loadingStatus } = action

        if (loadingStatus == 'loaded') {
            const state = getState()
            const mainMediaHasPayment = mainMediaHasPaymentHotspots(state)
            const paymentProperties = getPaymentProperties()(getState)

            if (mainMediaHasPayment) {
                return trackEvent(EVENTS.EXP_SCENEPAY_AVAILABLE, paymentProperties)
            }
        }
    },
}

export default paymentDesktopAnalytics
